import gql from 'graphql-tag.macro';

export const query = gql`
  query {
    positions {
      id
      title
      lastUsedAt
      summary
      additionalDetails
      activeJrCount
      updatedAt
      taskStatements {
        id
        task
      }
      badges {
        id
        name
        category
      }
      workContexts {
        id
        elementName
        group
      }
      dressCodeRequirements {
        id
        requirementGroup
        description
      }
      dressCodeEnvironments {
        employerDescription
        label
        id
      }
    }
  }
`;

const reducer = (data) => data.positions;

export const getPositions = {
  query,
  reducer,
};
